import React from 'react';

const PaginationLoader = () => {
  return (
    <div className="section-loader loading">
      <ul className="loading-dots">
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>
  );
};

export default PaginationLoader;
